import REQUESTS from "../../api/requests";
import { useEffect, useState, useRef, useContext } from "react";
import { Table, Modal, DatePicker, Input, Button } from "antd";
import classes from "./index.module.scss";
import MyIcon from "../../components/myicon";
import ICONS from "../../config/icons";
import { emptyContext } from "../../context_empty/context_empty";
import {
  CheckCircleOutlined,
  CalendarOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import getMyDate from "../../components/getMyDate";
import { useSelector } from "react-redux";
import { selectTranslation } from "../../features/Translation/TranslationSlice";
import TEXT from "../../config/text";
import showPropsConfirm from "../../components/showPropsConfirm";
import InitialParams from "../../components/InitialParams";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
const { RangePicker } = DatePicker;
const { confirm } = Modal;

function Activation() {
  const [empty, setEmpty] = useContext(emptyContext);
  const searchInput = useRef(null);
  const [searchParams] = useSearchParams();
  const [total, setTotal] = useState();
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [activation, setActivation] = useState([]);
  const [date, setDate] = useState("");
  const [sort, setSort] = useState(["id", "DESC"]);
  const [search, setSearch] = useState({
    comment: "",
  });

  InitialParams(setLimit, setCurrentPage, setSearch, setSort);

  const navigate = useNavigate();
  const goToPosts = (params) =>
    navigate({
      search: `?${createSearchParams(params)}`,
    });

  const translation = useSelector(selectTranslation);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
      return (
        <Input
          ref={searchInput}
          allowClear
          autoFocus
          placeholder="Type text here"
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
            confirm({ closeDropdown: false });
          }}
        />
      );
    },
    filterIcon: () => {
      return (
        <>
          <SearchOutlined />
        </>
      );
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      align: "center",
      render: (text, record, index) => {
        if (currentPage === 1) {
          return index + 1;
        } else {
          return limit * (currentPage - 1) + index + 1;
        }
      },
    },

    {
      title: `${translation["Reseller"] || TEXT["Reseller"]}`,
      dataIndex: "reseller",
      key: "name",
      align: "center",
      render: (record, text, index) => {
        if (record?.name && record?.surname) {
          return <p>{`${record?.name} ${record?.surname}`}</p>;
        } else {
          return <p>N/A</p>;
        }
      },
      ...getColumnSearchProps(),
    },

    {
      title: `${translation["Ip"] || TEXT["Ip"]}`,
      dataIndex: "ip",
      key: "ip",
      align: "center",
      ...getColumnSearchProps(),
    },

    {
      title: `${translation["Count"] || TEXT["Count"]}`,
      dataIndex: "count",
      key: "count",
      align: "center",
      sorter: true,
    },

    {
      title: `${translation["Transaction id"] || TEXT["Transaction id"]}`,
      dataIndex: "transaction_id",
      align: "center",
      key: "transaction_id",
      ...getColumnSearchProps(),
    },

    {
      title: `${translation["Price"] || TEXT["Price"]}`,
      dataIndex: "price",
      key: "price",
      sorter: true,
      align: "center",
      render: (record, text, index) => {
        return `${record} ${text?.currency ? text.currency : "N/A"}`;
      },
    },

    {
      title: `${translation["Payment method"] || TEXT["Payment method"]}`,
      dataIndex: "method",
      key: "method",
      sorter: true,
      align: "center",
    },

    {
      title: `${translation["Date"] || TEXT["Date"]}`,
      dataIndex: "createdAt",
      align: "center",
      sorter: true,
      render: (record) => {
        return getMyDate(record);
      },
      filterDropdown: ({}) => (
        <div
          style={{
            padding: 8,
          }}
        >
          <RangePicker
            size="small"
            onChange={(e, dateString) => setDate(dateString)}
            renderExtraFooter={() => "extra footer"}
          />
        </div>
      ),
      filterIcon: (filtered) => (
        <CalendarOutlined
          style={{
            color: JSON.parse(searchParams.get("between"))?.createdAt
              ? "#1890ff"
              : undefined,
          }}
        />
      ),
    },
  ];

  const getActivation = () => {
    setLoading(true);
    const query = {
      page: currentPage,
      limit,
      pagination: 1,
      sort: JSON.stringify(sort),
      search: {},
    };

    if (search.name) {
      query.search["$reseller.name$"] = search.name[0];
    }

    if (search.transaction_id) {
      query.search["transaction_id"] = search.transaction_id[0];
    }

    if (search.ip) {
      query.search["ip"] = search.ip[0];
    }

    if (search.reseller) {
      query.search["reseller"] = search.reseller[0];
    }

    if (query.search) {
      query.search = JSON.stringify(query.search);
    }

    if (date && date[0]) {
      let to = new Date(date[1]);
      to.setDate(to.getDate() + 1);
      query.between = JSON.stringify({
        createdAt: {
          from: new Date(date[0]),
          to: new Date(to),
        },
      });
    }

    goToPosts(query);
    REQUESTS.ACTIVATION.GET(query, (data) => {
      setTotal(data.count);
      // setLimit(data.limit);
      if (data.rows.length === 0 && currentPage !== 1) {
        setCurrentPage((current) => current - 1);
      } else {
        setCurrentPage(data.currentPage);
      }
      setLoading(false);
      setActivation(data.rows);

      if (!data.rows == []) {
        setEmpty(false);
      }
    });
  };

  useEffect(() => {
    return () => {
      setEmpty(true);
    };
  }, []);

  const handleTableChange = (pagination, filters, sorter) => {
    // if (sorter.field) {
    //   setSort([sorter.field, sorter.order === "ascend" ? "ASC" : "DESC"]);
    //}
    if (sorter.field) {
      setSort([sorter.field, sorter.order === "ascend" ? "ASC" : "DESC"]);
    }
    setSearch(filters);
    if (Object.values(filters)[0]) {
      //   setTitleSearch(Object.values(filters)[0].join(""));
    } else {
      //   setTitleSearch(null);
    }

    setCurrentPage(pagination.current);
    setLimit(pagination.pageSize);
  };

  useEffect(() => {
    let timout = setTimeout(() => {
      getActivation();
    }, 500);
    return () => {
      clearTimeout(timout);
    };
  }, [search, currentPage, limit, date, sort]);

  return (
    <div className={classes["Activation_list_table"]}>
      <div className={classes["Activation_list_title"]}>
        <p className={classes["Activation_title-text"]}>
          {/* <CheckCircleOutlined />{" "} */}
          {translation["Cretid"] || TEXT["Credit"]}
        </p>
      </div>

      <Table
        loading={loading}
        rowKey="id"
        columns={columns}
        dataSource={activation}
        onChange={handleTableChange}
        pagination={{
          position: ["bottomCenter"],
          current: currentPage,
          total: total,
          pageSize: limit,
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
        size="small"
      />
    </div>
  );
}

export default Activation;
